/**
 * Provides a mechanism for rendering a template directly.
 * @module app/views/BasicView
 */
import Backbone from "backbone";
var BasicView = Backbone.View.extend({
  /**
   * Initializes the view.
   * @param  {object} options The options hash. Passed directly to the template when rendering.
   * @param {string} options.template The template to render.
   */
  initialize: function (options) {
    this.options = options;

    this.template = options.template;
  },

  render: function () {
    this.$el.html(this.template(this.options));
  },
});

export default BasicView;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/BasicView.js
// module id = 953
// module chunks = 1